globalThis.SATSIM_VERSION = "0.15.1";

export { default as Universe } from './engine/Universe.js'
export { default as Event } from './engine/event/Event.js'
export { default as EventQueue } from './engine/event/EventQueue.js'
export { default as CommandBus } from './engine/command/CommandBus.js'
export { default as CommandError } from './engine/command/CommandError.js'
export {
  commandSchemaVersion,
  commandSchemas,
  commandUnionSchema,
  createDefaultCommandBus,
  getCommandSchema,
  getRuntimeAnalogCommandType,
  getRuntimeCommandMetadata,
  registerBuiltInCommands,
  runtimeAnalogCommandMetadataEntries,
  runtimeCommandMetadataEntries,
  runtimeCommandUnionSchema,
  scheduledCommandUnionSchema
} from './engine/command/index.js'

export { default as Node } from './engine/graph/Node.js'
export { default as Group } from './engine/graph/Group.js'
export { default as TransformGroup } from './engine/graph/TransformGroup.js'

export { default as AzElGimbal } from './engine/objects/AzElGimbal.js'
export { default as Earth } from './engine/objects/Earth.js'
export { default as EarthGroundStation } from './engine/objects/EarthGroundStation.js'
export { default as ElectroOpicalSensor } from './engine/objects/ElectroOpticalSensor.js'
export { default as EphemerisObject } from './engine/objects/EphemerisObject.js'
export { default as FastSteeringMirror } from './engine/objects/FastSteeringMirror.js'
export { default as Gimbal } from './engine/objects/Gimbal.js'
export { default as Laser } from './engine/objects/Laser.js'
export { default as LagrangeInterpolatedObject } from './engine/objects/LagrangeInterpolatedObject.js'
export { default as SGP4Satellite } from './engine/objects/SGP4Satellite.js'
export { default as SimObject } from './engine/objects/SimObject.js'
export { default as TwoBodySatellite } from './engine/objects/TwoBodySatellite.js'
export { default as AirVehicle } from './engine/objects/AirVehicle.js'
export { default as Observatory } from './engine/objects/Observatory.js'

export { default as SessionManager } from './runtime/SessionManager.js'
export { default as SimulationRuntime } from './runtime/SimulationRuntime.js'
export { default as RuntimeClient } from './runtime/RuntimeClient.js'
export {
  ControllerRegistry,
  createDefaultControllerRegistry,
  FsmController,
  GimbalController,
  registerBuiltInControllers,
  SensorZoomController
} from './runtime/controllers/index.js'
export * as Runtime from './runtime/index.js'

export { default as CallbackPositionProperty } from './engine/cesium/CallbackPositionProperty.js'
export { default as CompoundElementVisualizer } from './engine/cesium/CompoundElementVisualizer.js'
export { default as CoverageGridVisualizer } from './engine/cesium/CoverageGridVisualizer.js'
export { default as GeoBeltVisualizer } from './engine/cesium/GeoBeltVisualizer.js'
export { default as LaserBeam } from './engine/cesium/LaserBeam.js'
export { default as SensorFieldOfRegardVisualizer } from './engine/cesium/SensorFieldOfRegardVisualizer.js'
export { default as SensorFieldOfVIewVisualizer } from './engine/cesium/SensorFieldOfVIewVisualizer.js'

export { default as InfoBox } from './widgets/InfoBox.js'
export { default as Toolbar } from './widgets/Toolbar.js'
export { createViewer, mixinViewer } from './widgets/Viewer.js'

export { fetchTle, parseTle } from './io/tle.js'
export { southEastZenithToAzEl, spaceBasedToAzEl } from './engine/dynamics/gimbal.js'
export { normalizeAxisSlewConfig, stepSlewAxis } from './engine/dynamics/slew.js'
export { cloneWaypointRoute, compileWaypointRoute, evaluateWaypointRouteState } from './engine/dynamics/waypoint.js'
export { getVisibility } from './engine/geometry/visibility.js'
export { getShadowStatus, ShadowState } from './engine/geometry/shadow.js'

export { applyIau2006XysDataPatch } from './engine/cesium/Iau2006XysDataLocal.js'

// @TODO warning scenario prototype, will be refactored
export * as Scenario from './scenario/index.js'

// Export commonly used Cesium classes for CDN usage
export { 
  Math as CesiumMath,
  JulianDate, 
  ClockStep,
  ClockRange,
  Cartesian3,
  Cartesian2,
  Color,
  Matrix3,
  Matrix4,
  Quaternion,
  HeadingPitchRoll,
  Transforms,
  Ellipsoid,
  EllipsoidGeodesic,
  CesiumTerrainProvider,
  createWorldTerrainAsync,
  Ion
} from 'cesium';
